module.exports = __webpack_public_path__ + "static/media/bmw.0d5bd4eb.jpg";